<template>
  <div class="drop-spot-select">
    <TitleFrame :menubar=true text="立ち寄り箇所選択">
      <template slot="contents">
        <SpotCongestion/>
        <div
          :class="{'selected':selectedSpot, 'not-selected':!selectedSpot}"
          class="map-area"
        >
          <GoogleMap
            v-if="DepLatLng && DesLatLng"
            :selected-spot-type="selectedSpotType"
          />
          <!-- 立ち寄り選択せずに次へ -->
          <TextLink v-if="!selectedSpot && search.destination!=='現在地'" text="立ち寄り選択せずに次へ" @click-text="onClickNoDrop" />
        </div>
        <div v-if="selectedSpot" class="spot-data">
          <div class="title-area">
            <div class="big-bold-text">{{selectedSpot.name}}</div>
            <div class="close-button" @click="closeMiniWindow">×</div>
          </div>
          <div class="text-area">
            <div class="texts">
              <div class="link-text">
                <TextLinkInline text="今すぐ行く" @click-text="onClickGoNow" />
              </div>
              <div class="link-text">
                <TextLinkInline text="詳細をみる" @click-text="onClickDetail" />
              </div>
            </div>
          </div>
          <br>
          <div class="text">混雑度：{{selectedSpotCongestion}}</div>
          <div v-if="!(selectedSpotMeasure==='不明') && !(selectedSpotMeasure.length===0)">
            <div class="text">コロナ対策:
              <span v-if="selectedSpotMeasure==='不明'">不明</span>
              <span v-else-if="selectedSpotMeasure.length===0">不明</span>
              <span v-else>
                <span v-for="(item, index) in selectedSpotMeasure" :key="index">
                  <span v-if="item.measure.name === 'その他'">{{item.comment}}</span>
                  <span v-else>{{item.measure.name}}</span>
                <span v-if="index !== (selectedSpotMeasure.length-1)">、</span>
                </span>
              </span>
            </div>
          </div>

          <div class="image-area">
            <div class="img-area" v-for="(item, index) in selectedSpot.photos" :key="index">
              <img class="img" :src=loadGoogleImage(item)>
            </div>
          </div>
        </div>
      </template>
    </TitleFrame>
    <SpotExamples
      :selectedSpot="selectedSpotType"
      @select-spot="onSelectSpotType"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import TitleFrame from '@/components/Templates/TitleFrame'
import TextLinkInline from '@/components/Atoms/TextLinkInline'
import TextLink from '@/components/Atoms/TextLink'
import SpotCongestion from '@/components/Organisms/SpotCongestion'
import SpotExamples from '@/components/Organisms/SpotExamples'
import GoogleMap from '@/components/Organisms/GoogleMap'
import Firebase from './../../firebase'

export default {
  name: 'drop-spot-select',
  components: {
    TitleFrame,
    TextLinkInline,
    SpotCongestion,
    SpotExamples,
    GoogleMap,
    TextLink
  },
  computed: {
    ...mapState([
      'search',
      'currentLat',
      'currentLng',
      'originalApiData',
      'selectedSpot',
      'selectedSpotType',
      'isAgreed',
      'isAnswered',
      'DepLatLng',
      'DesLatLng',
      'uid'
    ]),
    selectedSpotCongestion () {
      if (this.selectedSpot) {
        var reportList
        let oriData = this.originalApiData.filter(x => x.service_place_id === this.selectedSpot.place_id)[0]
        if (oriData) reportList = oriData.reports
        if (this.selectedSpot.reports) reportList = this.selectedSpot.reports
        if (!reportList) return '不明'

        let sortList = Array.from(reportList).sort(function (a, b) {
          return (a.created_at < b.created_at ? 1 : -1)
        })

        let num = 0
        if (sortList.length) {
          num = sortList[0].congestion
        }
        if (num === 0) return '不明'
        if (num === 1) return '定員の半分以下'
        if (num === 2) return '待ち時間無し'
        if (num === 3) return '待ち時間10分以上'
        if (num === 4) return '待ち時間30分以上'
        if (num === 0) return '不明'
      }
      return '不明'
    },
    selectedSpotMeasure () {
      if (this.selectedSpot) {
        let oriData = this.originalApiData.filter(x => x.service_place_id === this.selectedSpot.place_id)[0]
        if (oriData) return oriData.measure_spots
        if (this.selectedSpot.measure_spots) return this.selectedSpot.measure_spots
      }
      return '不明'
    },
    coockieUid () {
      return this.$cookies.get('uid')
    }
  },
  data () {
    return {
    }
  },
  methods: {
    ...mapMutations([
      'loadingStart',
      'loadingEnd',
      'openModalAll',
      'resetSelectedSpot',
      'setSelectedSpotType',
      'setDropDestionaton'
    ]),
    sortArray (array) {
      array.sort(function (a, b) {
        return (a.created_at < b.created_at ? 1 : -1)
      })

      return array
    },
    closeMiniWindow () {
      this.resetSelectedSpot()
    },
    loadGoogleImage (e) {
      return e.getUrl()
    },
    onClickGoNow () {
      let latlng
      if (this.selectedSpot.geometry) latlng = this.selectedSpot.geometry.location
      else latlng = new window.google.maps.LatLng(this.selectedSpot.lat, this.selectedSpot.lon)

      this.setDropDestionaton({latlng: latlng, name: this.selectedSpot.name})
      Firebase.putLog({ ActionType: 'ChooseSpot' })
      this.$router.push({name: 'RouteResult'})
    },
    onClickNoDrop () {
      this.setDropDestionaton({latlng: this.DesLatLng, name: this.search.destination})
      Firebase.putLog({ ActionType: 'DepartDirectly' })
      this.$router.push({name: 'RouteResult'})
    },
    onClickDetail () {
      Firebase.getSpot()
      Firebase.putLog({ ActionType: 'SeeDetail' })
      this.openModalAll()
    },
    onSelectSpotType (e) {
      this.resetSelectedSpot()
      this.setSelectedSpotType(e)
    }
  },
  mounted () {
    this.loadingStart()
    if (!this.coockieUid || !this.uid) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAgreed) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.isAnswered) {
      this.$router.push({name: 'Consent'})
    }
    if (!this.DepLatLng && !this.DesLatLng) {
      this.$router.push({name: 'RouteSearch'})
    }
    this.setSelectedSpotType('飲食店')
    this.loadingEnd()
  },
  beforeDestroy () {
    this.resetSelectedSpot()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './../../unified.scss';
.drop-spot-select{
  height: 100%;
}
.text {
  font-size:0.8rem;
  margin: 0.2rem 0rem;
}
.big-bold-text{
  font-weight: bold;
  margin: 0.2rem 0rem;
}
.selected{
  height:calc(100% - 13rem);
}
.not-selected{
  height: calc(100% - 6rem);
}
.spot-data{
  padding: 0.5rem 0rem 0rem 0rem;
  visibility: show;
  max-height: 13rem;
  overflow: scroll;
}
.image-area{
  width:100%;
  display:flex;
  overflow: scroll;
}
.img-area{
  align-items: center;
  display: flex;
}
.img{
  max-width:7rem;
  max-height:6rem;
  margin:0.2rem 0.5rem;
}
.text-area{
  display: flex;
  justify-content: center;
}
.texts{
  display:flex;
  width:13rem;
  justify-content: space-between;
}
.title-area{
  display:flex;
  justify-content: space-between;
}
.close-button{
  font-size: 1.5rem;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/DropSpotSelect.vue